<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <div class="login-logo"><img src="https://exportedu.ru/images/logos/main-logo-coloured.png"/></div>
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="login">
                  <h1>Вход</h1>
                  <p class="text-muted">CRM &laquo;Акселератор&raquo;</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" v-model="email" class="form-control" placeholder="Email" autocomplete="username email" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" v-model="password" class="form-control" placeholder="Пароль" autocomplete="current-password" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <button type="submit" class="px-4 btn btn-primary">Вход</button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <a href="https://exportedu.ru/user/restore">Забыли пароль?</a>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h4>Если у Вас есть аккаунт на портале Школы Экспорта РЭЦ, нажмите ссылку ниже:</h4>
                  <a :href="'https://' + isBeta + 'exportedu.ru/user/login?redirect=crm'" variant="primary" class="active mt-3 btn btn-primary">Войти через&nbsp;&nbsp;<img width="24" src="/img/logo-white.png" /></a>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import client from '../../backend/client'
import Config from '../../assets/config'
import * as AppStorage from '../../storage/appstorage';

export default {
  name: 'Login',
    data: function() {
      return {
          email: null,
          password: null,
          isBeta: Config.APP_MODE ? Config.APP_MODE : ''
      }
    },
    mounted() {

        let token = this.$route.query.access_token;

        if(typeof token !== 'undefined') {
            AppStorage.set("token", token);
            window.location.href = '/login';
        }

        client.get('api/user')
            .then(res => {
                AppStorage.set("user", JSON.stringify(res.data));
                // now send the user to the next route
                this.$router.push({
                    path: "/"
                });
            })
            .catch(() => {
                localStorage.clear();
                this.$router.push({
                    path: "/login"
                });
            })
    },
  methods: {
      login: function () {
          localStorage.clear();
          client.get('/oauth/v2/token', {
              params: {
                  client_id: Config.API.clientId,
                  grant_type: 'password',
                  username: this.email,
                  password: this.password
              }
          }).then(res => {
                  // store the data in localStorage
              AppStorage.set("token", res.data.access_token);
              AppStorage.set("refresh", res.data.refresh_token);
              this.$router.go();
          })
      }
  }
}
</script>

<style>
  .login-logo {
    text-align: center;
    margin: -30px 0 20px;
  }
</style>
